// extracted by mini-css-extract-plugin
export var typingIndicator = "_hw-0";